<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/6chap1#chap1">Prelude: February 7, 1979</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/8chap2#chap2">Part One PROMISE: 1928–1950</a></p>
<p class="toc2"><a href="#/9chap3#chap3">1</a></p>
<p class="toc2"><a href="#/10chap4#chap4">2</a></p>
<p class="toc2"><a href="#/11chap5#chap5">3</a></p>
<p class="toc2"><a href="#/12chap6#chap6">4</a></p>
<p class="toc2"><a href="#/13chap7#chap7">5</a></p>
<p class="toc2"><a href="#/14chap8#chap8">6</a></p>
<p class="toc2"><a href="#/15chap9#chap9">7</a></p>
<p class="toc2"><a href="#/16chap10#chap10">8</a></p>
<p class="toc2"><a href="#/17chap11#chap11">9</a></p>
<p class="toc2"><a href="#/18chap12#chap12">10</a></p>
<p class="toc2"><a href="#/19chap13#chap13">11</a></p>
<p class="toc2"><a href="#/20chap14#chap14">12</a></p>
<p class="toc2"><a href="#/21chap15#chap15">13</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/22chap16#chap16">Part Two GLORY: 1966–1969</a></p>
<p class="toc2"><a href="#/23chap17#chap17">14</a></p>
<p class="toc2"><a href="#/24chap18#chap18">15</a></p>
<p class="toc2"><a href="#/25chap19#chap19">16</a></p>
<p class="toc2"><a href="#/26chap20#chap20">17</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/27chap21#chap21">Part Three BETRAYAL: 1969–1979</a></p>
<p class="toc2"><a href="#/28chap22#chap22">18</a></p>
<p class="toc2"><a href="#/29chap23#chap23">19</a></p>
<p class="toc2"><a href="#/30chap24#chap24">20</a></p>
<p class="toc2"><a href="#/31chap25#chap25">21</a></p>
<p class="toc2"><a href="#/32chap26#chap26">22</a></p>
<p class="toc2"><a href="#/33chap27#chap27">23</a></p>
<p class="toc2"><a href="#/34chap28#chap28">24</a></p>
<p class="toc2"><a href="#/35chap29#chap29">25</a></p>
<p class="toc2"><a href="#/36chap30#chap30">26</a></p>
<p class="toc2"><a href="#/37chap31#chap31">27</a></p>
<p class="toc2"><a href="#/38chap32#chap32">28</a></p>
<p class="toc2"><a href="#/39chap33#chap33">29</a></p>
<p class="toc2"><a href="#/40chap34#chap34">30</a></p>
<p class="toc2"><a href="#/41chap35#chap35">31</a></p>
<p class="toc2"><a href="#/42chap36#chap36">32</a></p>
<p class="toc2"><a href="#/43chap37#chap37">33</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/44chap38#chap38">Part Four EXILE: 1979–1981</a></p>
<p class="toc2"><a href="#/45chap39#chap39">34</a></p>
<p class="toc2"><a href="#/46chap40#chap40">35</a></p>
<p class="toc2"><a href="#/47chap41#chap41">36</a></p>
<p class="toc2"><a href="#/48chap42#chap42">37</a></p>
<p class="toc2"><a href="#/49chap43#chap43">38</a></p>
<p class="toc2"><a href="#/50chap44#chap44">39</a></p>
<p class="toc2"><a href="#/51chap45#chap45">40</a></p>
<p class="toc2"><a href="#/52chap46#chap46">41</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/53chap47#chap47">Part Five RETURN: 1981–1985</a></p>
<p class="toc2"><a href="#/54chap48#chap48">42</a></p>
<p class="toc2"><a href="#/55chap49#chap49">43</a></p>
<p class="toc2"><a href="#/56chap50#chap50">44</a></p>
<p class="toc2"><a href="#/57chap51#chap51">45</a></p>
<p class="toc2"><a href="#/58chap52#chap52">46</a></p>
<p class="toc2"><a href="#/59chap53#chap53">47</a></p>
<p class="toc2"><a href="#/60chap54#chap54">48</a></p>
<p class="toc2"><a href="#/61chap55#chap55">49</a></p>
<p class="toc2"><a href="#/62chap56#chap56">50</a></p>
<p class="toc2"><a href="#/63chap57#chap57">51</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/64chap58#chap58">Acknowledgements</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/65about#about">About the Author</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4-TOC.vue?61667d7b